export default __webpack_public_path__ + "static/media/daily-double.4cbb1917.mp3";